import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'arrow-elbow-left', 'IconArrowElbowLeft', [["path",{"d":"M3 14v-6h6","key":"svg-0"}],["path",{"d":"M3 8l9 9l9 -9","key":"svg-1"}]]);